import type { FaireProductEntity } from "../../entity_types/product";

export const p_9i2moo466b: FaireProductEntity = {
  token: "p_9i2moo466b",
  type: "product",
  name: "Cactus Flower Candle",
  brandToken: "b_oaph28jf",
  brandName: "dilo",
  imageUrl:
    "https://cdn.faire.com/fastly/05289b727ffd26ad1ba2e3c46950d59f2c223534efc692130f128ae4388da74d.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b00ac7f300c31984481a5eb413743d8b8e0855d49777c3764507f5fbbb93a7bf.jpeg",
    "https://cdn.faire.com/fastly/f7aac46682df1a7bc194ab89e80b7cd48c3d1fac300ef4221f3911f26d091903.jpeg",
  ],
  priceDollars: 16,
  description:
    "dilo candles are hand poured and made using 100% USA grown Soy Wax. \n\nDesigned and poured at dilo Studios in Philadelphia.\n\nTop Notes: Agave - Black Pepper - Yuzu\nHeart: Cactus Flower - Jade - Moringa\nBase: Patchouli - Redwood\n\n8.5 ounces - Burns 45 Hours\nAll candles are Phthalate-free, using cotton wicks with no lead cores for safer, cleaner burning.\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:03.379Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
